import React from "react";

export const PageContentLoadingIndicator = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <p className="text-lg font-semibold">Loading...</p>
    </div>
  );
};
